import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { Optional, TimetableControl } from "../components/Form";

type TimeTableRange = {
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
};
export interface ICreateTimetableValues {
  Monday: TimeTableRange;
  Tuesday: TimeTableRange;
  Thursday: TimeTableRange;
  Wednesday: TimeTableRange;
  Friday: TimeTableRange;
  Saturday: TimeTableRange;
  Sunday: TimeTableRange;
}

interface ITimetableForm {
  onSubmit: (values: ICreateTimetableValues) => void;
  initialValues?: Optional<ICreateTimetableValues>;
}

export const TimetableForm: React.FC<ITimetableForm> = ({
    onSubmit,
    initialValues
}) => {
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        return errors;
    };

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                    <TimetableControl name="Monday" label="E hënë" />
                    <TimetableControl name="Tuesday" label="E martë" />
                    <TimetableControl name="Thursday" label="E mërkurë" />
                    <TimetableControl name="Wednesday" label="E enjte" />
                    <TimetableControl name="Friday" label="E premte" />
                    <TimetableControl name="Saturday" label="E shtunë" />
                    <TimetableControl name="Sunday" label="E dielë" />

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            Ruaj
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            Pastro
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
